<template>
  <Panel v-bind:show="showPanel" :orientation="viewport >= 900 ? 'side' : 'bottom'">
    <div class="dancer-profile">
      <Story v-if="dancerFocus !== false" :duration="5000" :key="dancerFocus.name || false" :loadedElements="loadedStoryComponents[dancerFocus.name] || 0">
        <template v-slot:nav-ui>
          <CloseButton width="32px" height="32px" fill="#dd2b35" @click="panelClose($event)" />
        </template>
        <template v-slot:content>
          <!-- Note: load method needs to pass same reference string name as the story's ref -->
          <img
            @load="loadedStoryElement(dancerFocus.name)"
            v-for="(path, index) in dancerFocus.images.gallery"
            v-bind:src="`https://d26dmzpiksq0q.cloudfront.net/shared/ccd/2023/${path}`"
            v-bind:key="index"
          />
        </template>
        <template v-slot:loader>
          <Loader />
        </template>
      </Story>
      <h2>{{ dancerFocus.name }}</h2>
      <div class="bio">
        <div>
          <h4>Year:</h4>
          <p v-html="dancerFocus.tenure"></p>
        </div>
        <div>
          <h4>Occupation:</h4>
          <p v-html="dancerFocus.occupation"></p>
        </div>
        <div>
          <h4>Favorite TV Show:</h4>
          <p v-html="dancerFocus.show"></p>
        </div>
        <div>
          <h4>Favorite Candy:</h4>
          <p v-html="dancerFocus.candy"></p>
        </div>
        <div>
          <h4>Favorite Quote:</h4>
          <p v-html="dancerFocus.quote"></p>
        </div>
      </div>
    </div>
  </Panel>
  <div v-show="viewport >= 850" className="socials">
    <span>
      <a href="https://www.instagram.com/clutchcitydancers/" target="_blank">
        <InstagramIcon width="32px" height="32px" />
      </a>
    </span>
    <span>
      <a href="https://www.facebook.com/OfficialCCD/" target="_blank">
        <FacebookIcon width="32px" height="32px" />
      </a>
    </span>
    <span>
      <a href="https://twitter.com/officialccd" target="_blank">
        <TwitterIcon width="32px" height="32px" />
      </a>
    </span>
  </div>

  <div class="hero slideshow">
    <div style="margin: 0 auto; padding: 0 12px; max-width: 400px; background: #fff; border-radius: 0 0 24px 24px; position: relative; z-index: 2">
      <StaticCard :thumbnail="`https://d26dmzpiksq0q.cloudfront.net/shared/ccd-logo.svg`" :url="'#'" />
    </div>
    <div class="thumbnail">
      <img v-show="viewport >= 900" src="https://d26dmzpiksq0q.cloudfront.net/shared/ccd/2023/2023-CCD-Team.webp" />
      <img v-if="viewport < 900" src="https://d26dmzpiksq0q.cloudfront.net/shared/ccd/2023/2023-CCD-Team-800-x-640.webp" />
    </div>
  </div>
  <h2 class="headline">Meet The Team</h2>
  <div class="content">
    <div :style="`width:${viewport >= 900 ? '85%' : '100%'}; order:${viewport >= 900 ? 2 : 2};`">
      <!-- Dancer Grid -->
      <Grid :columns="viewport >= 1000 ? 7 : 3" gap="12px">
        <RoundedCard
          v-for="(dancer, index) in dancers"
          :thumbnail="`https://d26dmzpiksq0q.cloudfront.net/shared/ccd/2023/${dancer.images.thumbnailFront}`"
          borderStyle="solid 1px #CCC"
          :title="dancer.name"
          @click="panelClick(index, $event)"
          :key="index"
          innerPadding="8px"
          :titleSize="viewport >= 500 ? '16px' : '11px'"
        />
      </Grid>
    </div>
  </div>
  <h3 v-if="viewport < 900" class="headline">Follow Us</h3>
  <div v-if="viewport < 900" style="width: 200px; display: flex; justify-content: center; margin: 12px auto; border: solid 1px #ccc; border-radius: 22px">
    <a style="padding: 6px" href="https://www.instagram.com/clutchcitydancers/" target="_blank">
      <InstagramIcon width="32px" height="32px" />
    </a>
    <a style="padding: 6px" href="https://www.facebook.com/OfficialCCD/" target="_blank">
      <FacebookIcon width="32px" height="32px" />
    </a>
    <a style="padding: 6px" href="https://twitter.com/officialccd" target="_blank">
      <TwitterIcon width="32px" height="32px" />
    </a>
  </div>
  <div id="curator-feed-clutch-city-dancers-layout"></div>
  <div class="footer">
    <h3>Sponsors</h3>
    <p>RickStar Photography</p>
    <p>Jennifer Elizondo of Oasis Salon &amp; Medi Spa</p>
    <p>Beauty by Nikki Nicole</p>
    <p>Marcus Knox &amp; Wes Simon of Oak Fitness</p>
    <p>Spay Tans by Madison Nicole</p>
    <p>Infinity Nail Spa</p>
  </div>
</template>

<script>
import axios from "axios";
import helpers from "./helpers";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import staticMedia from "./data/media";

import Grid from "./components/Grid.vue";
import StaticCard from "./components/StaticCard.vue";
import RoundedCard from "./components/RoundedCard.vue";
import Panel from "./components/Panel.vue";
import Story from "./components/Story.vue";
// import MediaLarge from "./components/MediaLarge.vue";
import CloseButton from "./components/CloseButton.vue";
import InstagramIcon from "./components/InstagramIcon.vue";
import FacebookIcon from "./components/FacebookIcon.vue";
import TwitterIcon from "./components/TwitterIcon.vue";
import Loader from "./components/Loader.vue";

//data sources
console.log(helpers);
export default {
  name: "App",
  data() {
    return {
      loaded: false,
      loadedStoryComponents: {},
      events: [],
      dancers: false,
      showPanel: false,
      dancerFocus: false,
      targetElement: null,
      viewport: 0,
      media: staticMedia.response.result.slice(0, 5).map((item) => {
        console.log(item);
        return {
          title: item.title,
          thumbnail: item.listImage.raw.url,
          url: `https://nba.com${item.url}`,
        };
      }),
    };
  },
  watch: {
    dancerFocus: function (value) {
      if (value !== true) {
        this.targetElement = document.querySelector(".panel .inner");
      }
    },
    showPanel: function (value) {
      console.log("thing", this.targetElement);
      if (value === true) {
        disableBodyScroll(this.targetElement);
        console.log("callced");
      } else {
        enableBodyScroll(this.targetElement);
      }
    },
  },
  methods: {
    panelClose: function (event) {
      console.log("close", event);
      this.dancerFocus = false;
      this.showPanel = false;
    },
    panelClick: function (index, event) {
      console.log(event);
      this.panelClose(null);
      this.dancerFocus = this.dancers[index];
      this.showPanel = true;
    },
    viewportUpdate: function () {
      this.viewport = parseInt(window.innerWidth, 10);
    },
    loadedStoryElement: function (ref) {
      if (!this.loadedStoryComponents[ref]) {
        this.loadedStoryComponents[ref] = 1;
      } else {
        this.loadedStoryComponents[ref] = this.loadedStoryComponents[ref] + 1;
      }
    },
  },
  components: {
    Grid,
    StaticCard,
    Story,
    Panel,
    // MediaLarge,
    RoundedCard,
    CloseButton,
    InstagramIcon,
    FacebookIcon,
    TwitterIcon,
    Loader,
  },
  mounted() {
    this.viewportUpdate();
    window.addEventListener("resize", this.viewportUpdate);
    this.targetElement = document.querySelector(".dancer-profile");
    axios
      .get("https://d26dmzpiksq0q.cloudfront.net/static/dancers.json")
      .then((res) => {
        // this.events = transformEvents(res.data).slice(0,5);
        this.dancers = res.data;
        console.log(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=The+Nautigal:wght@700&display=swap");
#app {
  width: 100%;
  /*text-align: center;*/
  /*color: #2c3e50;*/
}

#app .event-slider .swiper-container {
  padding-bottom: 40px;
}

#app h2,
h3,
h4 {
  font-weight: 600;
}
#app h2,
#app p {
  margin: 12px 0;
  padding: 0 5%;
}
#app .headline {
  width: 100%;
  margin: 12px auto;
  padding: 0;
  font-family: "The Nautigal", cursive;
  text-align: center;
  text-transform: none;
  line-height: 1;
  display: block;
  font-size: 44px;
}
#app h2.headline {
  margin: 36px auto 8px auto;
}
#app a.pill {
  padding: 12px 0;
  background: #fff;
  border-radius: var(--buttonBorderRadius);
  color: var(--primaryColor);
  font-size: 3vw;
  font-weight: 600;
  line-height: 1;
  text-transform: uppercase;
  text-align: center;
  text-decoration: none;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
}
#app .grid.dancer {
  grid-template-columns: repeat(var(--dancerGridColumns), 1fr);
}

#app .dancer-profile {
  width: 100%;
  padding: 0 0 48px 0;
  position: relative;
  overflow: scroll;
}
#app .bio {
  padding: 0 5%;
}
#app .bio h4 {
  margin: 0;
}
#app .bio p {
  margin-top: 0;
  padding: 0;
}
#app .content {
  width: 100%;
  padding: 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

#app .content > div {
  max-width: 1200px;
}
.socials {
  display: flex;
  position: absolute;
  margin: 10px;
  justify-content: space-around;
  right: 0;
  gap: 1rem;
  background: rgba(255, 255, 255, 0.95);
  z-index: 2;
  padding: 1rem;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
  transition: var(--clutchTranstion);
  border: solid 1px #ccc;
  border-radius: 22px;
}
.socials:hover {
  background: #fff;
}
.socials span {
  transition: all 0.1s ease-in-out;
}
.socials a {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}
.socials span:hover {
  scale: 1.2;
}
.hero {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 12px;
}
.thumbnail img {
  border-radius: 12px;
  width: 100%;
}
#app .prep-classes-link {
  width: 100%;
  max-width: 300px;
  margin: 12px auto 48px auto;
  padding: 12px;
  border-radius: var(--buttonBorderRadius);
  background: #dd2b35;
  grid-column: span 2;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
  display: block;
}

#app .media-video {
  background: black;
  border-radius: var(--cardBorderRadius);
  box-shadow: 0 12px 8px -10px rgba(0, 0, 0, 0.4);
  transition: all var(--transitionDuration) ease;
  overflow: hidden;
  height: fit-content;
  height: 100%;
  /* max-height: 80vh; */
}
#app .media-video video {
  width: 100%;
}
.flyer {
  width: 100%;
  border-radius: 10px;
  transition: all 300ms ease;
}
.flyer:hover {
  scale: 1.01;
}

@media screen and (max-width: 500px) {
  #app h2.headline {
    font-size: 10vw;
  }

  #app h3.headline {
    font-size: 6vw;
  }
}

#app .footer {
  width: 100%;
  background: rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

#app .footer h3 {
  /*width: 100%;*/
  font-weight: normal;
  text-align: center;
}

#app .footer p {
  max-width: 400px;
  margin: 12px 0;
  padding: 0 4px;
  font-size: 14px;
  text-align: center;
  line-height: 1.3;
  position: relative;
}

#app .footer p:after {
  width: 1px;
  height: 40px;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: calc(50% - 20px);
  right: 0;
  content: "";
}
#app .footer p:last-child:after {
  content: none;
}
#curator-feed-clutch-city-dancers-layout {
  margin: 36px auto;
  max-width: 1400px;
}
.crt-load-more {
  border-radius: 22px;
}
@media screen and (min-width: 801px) {
  #app .footer > * {
    width: 16.6%;
  }
}
@media screen and (max-width: 800px) {
  #app .footer h3 {
    width: 100%;
  }

  #app .footer p {
    width: 33.3%;
  }
}

@media screen and (max-width: 600px) {
  #app .footer p {
    width: 100%;
    margin: 0;
    padding: 12px 8px;
    border-top: solid 1px rgba(0, 0, 0, 0.3);
  }

  #app .footer p:after {
    content: none;
  }
}
</style>
